(ns ballot-scout-v2-frontend.email.views
  (:require
   [ballot-scout-v2-frontend.email.subs :as s.email]
   [ballot-scout-v2-frontend.layout.page-content :refer [landing-page]]
   [ballot-scout-v2-frontend.widget.i18n :as i18n :refer [tr]]
   [re-frame.core :as rf]))

(defn email-page-text [text]
  [:h3 {:class "email-page-text"} text])

(defn verify-email-page []
  (let [success @(rf/subscribe [::s.email/verify-email-success])
        failure @(rf/subscribe [::s.email/verify-email-failure])]
    [landing-page
     (cond success
           [:div
            [email-page-text (tr [:thank-you!])]
            [email-page-text (tr [:you-have-signed-up-to-email-notys])]]
           failure
           [:div
            [email-page-text (tr [:sorry!])]
            [email-page-text (tr [:could-not-verify-email])]]
           :else
           [:div
            [:div.loading
             [:img.centered-img {:style {:padding "2em"} :src "/images/compass-100x100.png"}]]
            [:p (tr [:loading-ellipses])]])]))

(defn unsubscribe-email-page []
  (let [success @(rf/subscribe [::s.email/unsubscribe-email-success])
        failure @(rf/subscribe [::s.email/unsubscribe-email-failure])]
    [landing-page
     (cond success
           [:div
            [email-page-text (tr [:you-have-been-unsubscribed-from-email-notys])]]
           failure
           [:div
            [email-page-text (tr [:sorry!])]
            [email-page-text (tr [:error-processing-unsubcribe])]]
           :else
           [:div
            [:div.loading
             [:img.centered-img {:style {:padding "2em"} :src "/images/compass-100x100.png"}]]
            [:p (tr [:loading-ellipses])]])]))
